import { BaseLocation } from "src/services/subscription/base-locations.enum";

import { Rack } from "src/services/item/rack.interface";
import { Vehicle } from "src/services/item/vehicle.interface";

export interface ItemQrCode {
  baseLocation: BaseLocation;
  customerName: string;
  itemId: string;
  rocketClosetPhoneNumber: string;
}

export interface RackQrCode extends Rack {
  baseLocation: BaseLocation;
}

export interface VehicleQrCode extends Vehicle {}

export function isItemQrCode(input: unknown): input is ItemQrCode {
  return typeof input === "object" && !!input && "itemId" in input;
}

export function isRackQrCode(input: unknown): input is RackQrCode {
  return typeof input === "object" && !!input && "bay" in input && "number" in input && "row" in input;
}

export function isVehicleQrCode(input: unknown): input is VehicleQrCode {
  return typeof input === "object" && !!input && "licensePlate" in input;
}
